import getLocal from '@/app/utils/getLocal';
import classNames from 'classnames';
import React, { useRef } from 'react';
import { Navigation, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import './index.scss';
import EFPicture from '../ef-picture';
import { useGlobal } from '@/utils/useGlobal';

export interface EfEndorsementItemProps {
    /**
     * 文本文案
     */
    text: string;
    /**
     * 来源/引用 标题
     */
    title?: string;
    /**
     * 来源/引用 logo
     */
    logo?: string;
}

interface EfEndorsemenetsProps {
    /**
     * 样式名
     */
    className?: string;
    /**
     * 段落标题
     */
    title: string;
    /**
     * 列表
     */
    lists: EfEndorsementItemProps[];
}

/**
 * 维护: Kalkin
 *
 * 媒体评价列表(背书/推荐/引用): Voice of the Press
 */
const EfEndorsements: React.FC<EfEndorsemenetsProps> = ({ lists = [], title, className }) => {
    const { gtm } = useGlobal();
    const prefixCls = `ef-endorsements`;
    const classes = classNames(prefixCls, 'ef-container', {
        [`${className}`]: className,
    });

    const index = useRef(0);
    const handleGtm = (str: string) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_detail_page',
            list_name: title,
            button_name: str,
        });
    };

    return (
        <div className={classes}>
            <p className={`${prefixCls}-title`}>{title}</p>
            <Swiper
                className={`${prefixCls}-swiper-box`}
                // effect="fade"
                modules={[Scrollbar, Navigation]}
                spaceBetween={0}
                // centeredSlides={true}
                navigation={lists?.length > 1}
                slidesPerView={'auto'}
                initialSlide={0}
                scrollbar={{
                    hide: false,
                    draggable: true,
                    dragSize: 32,
                    snapOnRelease: true,
                }}
                onSlidePrevTransitionStart={() => {
                    index.current = index.current - 1;
                    handleGtm('<');
                }}
                onSlideNextTransitionStart={() => {
                    index.current = index.current + 1;
                    handleGtm('>');
                }}
            >
                {lists?.map((card: any, k: number) => (
                    <SwiperSlide className={`${prefixCls}-swiper-item ${prefixCls}-item-${k + 1}`} key={k}>
                        {card?.logo && <EFPicture className={`${prefixCls}-card-logo`} src={card?.logo} />}
                        {card?.text && <p className={`${prefixCls}-card-text`}>{card?.text}</p>}
                        {card?.title && <p className={`${prefixCls}-card-title`}>{card?.title}</p>}
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default EfEndorsements;
